const MAX_REMAINING_TIME = 6;

export default function useGetCalculatedProgressByDuration(savedProgress, duration) {
  const remainingTime = (savedProgress !== undefined && duration)
    ? (duration - savedProgress) : undefined;

  if (remainingTime !== undefined) {
    return remainingTime < MAX_REMAINING_TIME ? 0 : savedProgress;
  }

  return remainingTime;
}
